import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getFromAddress, getFromName, getSubject, getTimestamp
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getOriginalFromSenderEmail, getTORecipientRecords, getCCRecipientRecords, getBCCRecipientRecords, getEmailRecipientDeliveryIdentifierValue, getGenericChannelId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import * as TranslationOptions from 'conversations-message-history/email/constants/emailTranslationKeys';
import { List as ImmutableList } from 'immutable';
import CommonMessageHeaderPopoverListItemDescription from './CommonMessageHeaderPopoverListItemDescription';
import { OptionValueType } from './CommonMessageHeaderPopoverList';
import { getRecipientName } from '../common-message/operators/getMessageRecipientNames';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const buildListUI = (getter, message, friendlyNames) => {
  const listItems = getter(message).map(recipientRecord => {
    const deliveryIdentifier = getEmailRecipientDeliveryIdentifierValue(recipientRecord) || '';
    const bracketIndex = deliveryIdentifier.indexOf('<');
    const shouldParseEmail = bracketIndex > -1;
    const genericChannelId = getGenericChannelId(message);
    const listValue = shouldParseEmail ? `${deliveryIdentifier.substring(bracketIndex + 1, deliveryIdentifier.indexOf('>'))}` : deliveryIdentifier;
    const recipientName = friendlyNames ? getRecipientName({
      recipient: recipientRecord,
      friendlyNames
    }) : null;

    // "display name" is used to signify a name we display that may be different than the friendly name. If the resolved friendly name
    // fell back to be the email, then that recipient will not have a "display name" for the popover.
    const displayName = recipientName === deliveryIdentifier ? null : recipientName;
    return /*#__PURE__*/_jsx(CommonMessageHeaderPopoverListItemDescription, {
      value: `<${listValue}>`,
      valueType: OptionValueType.Email,
      copiableValue: listValue,
      genericChannelId: genericChannelId,
      displayName: displayName // if resolved friendly name fallback is same as deliveryIdentifier, will not display
    }, deliveryIdentifier);
  });
  return listItems.size ? /*#__PURE__*/_jsx(_Fragment, {
    children: listItems
  }) : null;
};
export const getEmailMessagePopoverContents = ({
  message,
  friendlyNames
}) => {
  const toAddressesList = buildListUI(getTORecipientRecords, message, friendlyNames);
  const fromName = getFromName(message);
  const fromAddress = getFromAddress(message);
  const ccList = buildListUI(getCCRecipientRecords, message, friendlyNames);
  const bccList = buildListUI(getBCCRecipientRecords, message, friendlyNames);
  const originalSenderEmail = getOriginalFromSenderEmail(message);
  const timestamp = getTimestamp(message);
  const subject = getSubject(message);
  let baseOptions = ImmutableList();
  if (fromName || fromAddress) {
    baseOptions = baseOptions.push({
      key: TranslationOptions.FROM,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.common-message.popover.from"
      }),
      data: {
        value: /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx("b", {
            children: fromAddress
          })
        }),
        copiableValue: fromAddress,
        valueType: OptionValueType.Email
      }
    });
  }
  if (toAddressesList) {
    baseOptions = baseOptions.push({
      key: TranslationOptions.TO,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.common-message.popover.to"
      }),
      data: {
        value: toAddressesList,
        valueType: OptionValueType.List
      }
    });
  }
  if (ccList) {
    baseOptions = baseOptions.push({
      key: TranslationOptions.CC,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.common-message.popover.cc"
      }),
      data: {
        value: ccList,
        valueType: OptionValueType.List
      }
    });
  }
  if (bccList) {
    baseOptions = baseOptions.push({
      key: TranslationOptions.BCC,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.common-message.popover.bcc"
      }),
      data: {
        value: bccList,
        valueType: OptionValueType.List
      }
    });
  }
  if (originalSenderEmail) {
    baseOptions = baseOptions.push({
      key: TranslationOptions.ORIGINAL_SENDER,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.common-message.popover.originalSender"
      }),
      data: {
        value: /*#__PURE__*/_jsx("span", {
          children: originalSenderEmail
        }),
        valueType: OptionValueType.Email
      }
    });
  }
  if (timestamp) {
    baseOptions = baseOptions.push({
      key: TranslationOptions.DATE,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.common-message.popover.date"
      }),
      data: {
        value: /*#__PURE__*/_jsx("span", {
          children: I18n.moment(timestamp).format('llll')
        }),
        valueType: OptionValueType.Date
      }
    });
  }
  if (subject) {
    baseOptions = baseOptions.push({
      key: TranslationOptions.SUBJECT,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.common-message.popover.subject"
      }),
      data: {
        value: /*#__PURE__*/_jsx("span", {
          children: subject
        }),
        valueType: OptionValueType.Subject
      }
    });
  }
  return baseOptions.toArray();
};